module.exports = __webpack_public_path__ + "img/motorcycle.0b844549.jpg";